module.exports = __webpack_public_path__ + "static/media/fo.f0bb08a7.svg";